
<div class="roles">
  <!--<label for="cname">Select Role</label>-->
  <label>Select Role</label>
  <div class="select-container">
    <select class="select" name="roles" [(ngModel)]="utilityobj.roleID">
      <option value="1" selected>Grantor</option>
      <option value="2">Grantee</option>
      <option value="0">Both</option>
    </select>
  </div>
</div>



